import { create } from 'zustand';
import type { UploadStore, UploadItemFile, UploadProgress } from '../types';

const initialUploadItem: UploadItemFile = {
  name: '',
  file: undefined,
  owner: '',
};

export const useUploadStore = create<UploadStore>((set, get) => ({
  // State
  isUploading: false,
  progress: null,
  error: null,
  currentItem: initialUploadItem,

  // Actions
  setUploading: (isUploading: boolean) => {
    set({ isUploading });
  },

  setProgress: (progress: UploadProgress | null) => {
    set({ progress });
  },

  setError: (error: string | null) => {
    set({ error });
  },

  setCurrentItem: (item: UploadItemFile | null) => {
    set({ currentItem: item || initialUploadItem });
  },

  resetUpload: () => {
    set({
      isUploading: false,
      progress: null,
      error: null,
      currentItem: initialUploadItem,
    });
  },

  // Computed
  isDisabled: (): boolean => {
    const state = get();
    return !state.currentItem?.file || !state.currentItem?.name || state.isUploading;
  },

  hasFile: (): boolean => {
    const state = get();
    return !!state.currentItem?.file;
  },
}));


export const getUploadActions = () =>  {
  const state = useUploadStore.getState()
  return {
    setUploading: state.setUploading,
    setProgress: state.setProgress,
    setError: state.setError,
    setCurrentItem: state.setCurrentItem,
    resetUpload: state.resetUpload,
  };
}


export const useUploadComputed = () => useUploadStore((state) => ({
  isDisabled: state.isDisabled(),
  hasFile: state.hasFile(),
}));